export default "__VITE_ASSET__1888d4f4__"